module.exports = __webpack_public_path__ + "static/media/corporate-img-mob.7cb3d0fc.png";